import React, { ReactNode } from 'react';

import { CardContainer } from 'common/components/Card/card.styled';
import { SummeryCardTitle } from 'common/components/Card/SummeryCard/SummeryCardTitle';

import { Items } from './SummeryCard.styled';

interface IProps {
  title?: string;
  onClick?: () => void;
  children?: ReactNode;
  margin?: string;
  actions?: ReactNode;
  cardActionsIconColor?: string;
}

export const SummeryCard = ({
  title,
  onClick,
  children,
  margin,
  actions,
  cardActionsIconColor,
}: IProps) => {
  return (
    <CardContainer margin={margin} onClick={onClick}>
      {title && (
        <SummeryCardTitle
          title={title}
          actions={actions}
          cardActionsIconColor={cardActionsIconColor}
        />
      )}
      <Items>{children}</Items>
    </CardContainer>
  );
};
